import type { ReactNode } from 'react'
import { Tabs } from '@base-ui/react/tabs'
import { twMerge } from 'tailwind-merge'
import { Loader2 } from 'lucide-react'
import type { PartProps } from '../../../lib/part-props'

interface TabProps extends PartProps<Tabs.Tab.Props> {
  className?: string
  isPending?: boolean
  children: ReactNode
}

function Tab({ className, isPending, children, ...props }: TabProps) {
  return (
    <Tabs.Tab
      className={twMerge(
        'text-foreground-secondary corner-squircle relative z-10 flex min-w-0 cursor-pointer items-center justify-center gap-1.5 whitespace-nowrap rounded-[calc(var(--tabs-radius)-var(--tabs-inset))] bg-transparent px-[var(--tabs-pad)] text-sm font-medium',
        '[&_svg:not([class*="size-"])]:size-3.5',
        'transition-colors duration-150 motion-reduce:transition-none',
        'hover:text-foreground data-[active]:text-foreground',
        'focus-visible:focus-ring',
        'data-[disabled]:text-foreground-disabled data-[disabled]:data-[active]:text-foreground-secondary data-[disabled]:cursor-not-allowed',
        className,
      )}
      {...props}
    >
      {children}
      {isPending && (
        // The spin goes on an HTML wrapper, not the svg, so it stays on the compositor.
        <span
          aria-hidden
          className="text-foreground-secondary inline-flex size-3.5 shrink-0 animate-spin motion-reduce:animate-none"
        >
          <Loader2 className="size-full" />
        </span>
      )}
    </Tabs.Tab>
  )
}

export { Tab }
